import { createSlice } from '@reduxjs/toolkit'

const initialState = {
    masked_source_url: null,
    template_id: null,
    content_type: null,
    thumbnail_url: null,
    file_url: null,
    generation_id: null,
    detected_face_urls: null,
    template_face_count: null,
    output_url: null,
    showBeforeAfterImage: false,
    ai_tool_id: null,
    content_id: null,
    publish_url: null,
    bg_flow: null,
    text_to_image_prompt: null,
    text_to_image_resolution: null,
    text_to_video_prompt: null,
    text_to_video_style: null,
    text_to_video_duration: null,
    image_to_video_prompt: null,
    image_to_video_duration: null,
    image_to_video_input_image_url: null,
    doMoreFlowFlag: false,
    generatedAudioUrl: null,
    orientation: null,
    AudioVideoMergedUrl:null,
    mergedAudioVideoData:null,
    text_to_video_outputs_count:null,
    text_to_video_aspectRatio: null,
    inputsResetCount: 0,
    is_asset_published: false,
    selected_ai_tool_id: null,
    child_ids: null,
    child_id: null,
    response: null
}

const SESSION_STORAGE_KEY = 'generation_session_persist_v1'

const loadSessionFromStorage = () => {
    if (typeof window === 'undefined') return initialState
    try {
        const raw = sessionStorage.getItem(SESSION_STORAGE_KEY)
        if (!raw) return initialState
        const parsed = JSON.parse(raw)
        Object.keys(parsed).forEach((k) => {
            if (typeof parsed[k] === 'string' && parsed[k].startsWith('blob:')) {
                parsed[k] = null
            }
        })
        return {
            ...initialState,
            ...parsed,
            output_url: null,
            generation_id: null,
            content_id: null,
            publish_url: null,
            child_ids: null,
            child_id: null,
            response: null,
            file_url: null,
            thumbnail_url: null,
            input_video_url: null,
            input_image_url: null
        }
    } catch (e) {
        return initialState
    }
}

const saveSessionToStorage = (sessionState) => {
    if (typeof window === 'undefined') return
    try {
        const sanitized = { ...sessionState }
        Object.keys(sanitized).forEach((k) => {
            if (typeof sanitized[k] === 'string' && sanitized[k].startsWith('blob:')) {
                sanitized[k] = null
            }
        })
        sessionStorage.setItem(SESSION_STORAGE_KEY, JSON.stringify(sanitized))
    } catch (e) {
        console.error('Failed to save session state', e)
    }
}

const generationSessionSlice = createSlice({
    name: 'generationSession',
    initialState: loadSessionFromStorage(),
    reducers: {
        updateGenerationSession: (state, action) => {
            if (action.payload && typeof action.payload === 'object') {
                Object.keys(action.payload).forEach((key) => {
                    if (action.payload[key] !== undefined) {
                        state[key] = action.payload[key]
                    }
                })
            }
            saveSessionToStorage(state)
        },
        resetGenerationSession: () => {
            if (typeof window !== 'undefined') {
                sessionStorage.removeItem(SESSION_STORAGE_KEY)
                try {
                    const allMedia = document.querySelectorAll('video, audio')
                    allMedia.forEach((media) => {
                        try { media.pause() } catch (e) {}
                    })
                } catch (e) {}
                if (window.splashPlayerObj) {
                    try {
                        if (typeof window.splashPlayerObj.pause === 'function') window.splashPlayerObj.pause()
                        if (window.splashPlayerObj.player && typeof window.splashPlayerObj.player.pause === 'function') window.splashPlayerObj.player.pause()
                        if (typeof window.splashPlayerObj.destroy === 'function') window.splashPlayerObj.destroy()
                    } catch (e) {}
                    delete window.playSplashVideo
                    delete window.splashPlayerObj
                }
            }
            return initialState
        },
        triggerInputsReset: (state) => {
            state.inputsResetCount = (state.inputsResetCount || 0) + 1
            saveSessionToStorage(state)
        }
    }
})

export const { updateGenerationSession, resetGenerationSession, triggerInputsReset } =
    generationSessionSlice.actions
export default generationSessionSlice.reducer
